import * as types from './mutations-types'

export default {
  [types.COUPON_INFO] (state, data) {
    state.couponInfo = data
  },
  [types.COUPON_INFO_EXPIRED] (state, data) {
    state.couponInfoExpired = data
  },
  [types.UPDATE_COUPON_INFO] (state, data) {
    state.couponInfo = state.couponInfo.map(item => {
      if (item.id === data.id) {
        item.state = true
      }
      return item
    })
  },
  [types.UPDATE_COUPON_INFO_FALSE] (state, data) {
    state.couponInfo = state.couponInfo.map(item => {
      if (item.id === data.id) {
        item.state = false
      }
      return item
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/store/mutations.js